<template>
  <iText
    v-if="editMode"
    v-bind="$attrs"
  >
    {{ editModePlaceholderText }}
  </iText>
  <iEditor
    v-else-if="storySegments.length"
    v-bind="$attrs"
    ref="editor"
    :key="playbackVersion"
    preview
    :branding-styles="getCssMappedConfiguration"
    :segments="renderableSegments"
    height="auto"
    overflow="none"
    variant="builder"
    width="fill"
  />
</template>

<script>
import { camelToSnakeCase } from "@bloglovin/vue-framework";
import { mapState } from "pinia";
import useBrandingStore from "%/dynamic-component-editor/stores/branding-store";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import { SeasonPageElementMixin } from "%/dynamic-component-editor/standard-pages/season-page/season-page-element-mixin";
import { useStoryStore } from "%/dynamic-component-editor/stores/story-store";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import { StoryVideoPlaybackMixin } from "%/mixins/story-video-playback-mixin";

export default {
  name: "SeasonContent",
  mixins: [DynamicElementMixin, SeasonPageElementMixin, StoryVideoPlaybackMixin],
  inheritAttrs: false,
  optionBundles: [
    LayoutWidthHeightOptions,
  ],
  elementPanelSettings: {
    displayIcon: "text",
    elementType: "season",
  },
  computed: {
    hidesUnresolvedMedia() {
      return !this.editMode;
    },
    ...mapState(useBrandingStore, [
      "getCssMappedConfiguration",
    ]),
    // Segment source the playback mixin resolves media-backed videos against.
    playbackSegments() {
      return this.storySegments;
    },
    editModePlaceholderText() {
      return "Season content will appear here";
    },
    storySegments() {
      if (!this.entity.storyId) {
        return [];
      }

      const storyStore = useStoryStore();

      const entity = storyStore.stories[this.entity.storyId];
      if (!entity.segments) {
        return [];
      }
      const segmentArray = Object.values(entity.segments);
      return entity.segmentOrder.map(segmentItem => {
        let segment = segmentArray.find(segmentData => segmentData.storySegmentId === segmentItem.storySegmentId);
        let formattedSegment = {};
        Object.keys(segment).forEach(segmentKey => {
          formattedSegment[camelToSnakeCase(segmentKey)] = segment[segmentKey];
        });
        return formattedSegment;
      });
    },
  },
};
</script>
